import mark from "../assets/brand/mark.png";
import logo from "../assets/brand/logo.png";
import { cn } from "../lib/utils";

/**
 * CELSZC brand mark / wordmark from the legacy app.
 * - mark: circular emblem (light & dark friendly)
 * - full: horizontal logo (best on dark backgrounds)
 */
export function BrandLogo({
  variant = "mark",
  className,
  imgClassName,
  showWordmark = false,
}) {
  const src = variant === "full" ? logo : mark;

  return (
    <span className={cn("inline-flex items-center gap-2.5", className)}>
      <img
        src={src}
        alt="CELSZC"
        className={cn(
          variant === "full" ? "h-8 w-auto object-contain" : "h-9 w-9 rounded-full object-cover",
          imgClassName
        )}
      />
      {showWordmark && variant === "mark" && (
        <span className="leading-tight">
          <span className="block font-bold tracking-tight">CELSZC</span>
          <span className="block text-[10px] uppercase tracking-wider opacity-60">
            Zonal Portal
          </span>
        </span>
      )}
    </span>
  );
}

export { mark as brandMark, logo as brandLogo };
